// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-netlify-i-18-n-workaround-src-pages-404-js": () => import("./../../node_modules/gatsby-netlify-i18n-workaround/src/pages/404.js" /* webpackChunkName: "component---node-modules-gatsby-netlify-i-18-n-workaround-src-pages-404-js" */),
  "component---node-modules-gatsby-netlify-i-18-n-workaround-src-templates-home-js": () => import("./../../node_modules/gatsby-netlify-i18n-workaround/src/templates/home.js" /* webpackChunkName: "component---node-modules-gatsby-netlify-i-18-n-workaround-src-templates-home-js" */)
}

